// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'  
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import App from './App'
import router from './router'
import { i18n } from '@/i18n';
import VeeValidate, { Validator } from 'vee-validate';
import store from '@/store/store'

//VUEX .AXIOS

Vue.use(Vuex);
axios.defaults.baseURL = store.state.server;

// Eventos para añadir arguments al dataLayer
Vue.mixin({
	methods: {
		eventGA(value) {
			window.dataLayer.push('event',
				'conversion', {
				'allow_custom_scripts': true,
				'send_to': value
			});

		},
	}
})

import VueFacebookPixel from 'vue-analytics-facebook-pixel'

Vue.use(VueFacebookPixel);

Vue.analytics.fbq.init('1973195416157246', {
	em: 'social@risi.es'
  })

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js